export const STATUS_ITEMS = ['Nova','Pendente','Em análise','Concluído']
export const TIPO_PESSOA = ['PF','PJ']